import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import { solucoes } from "@/data/solucoes";

type Group = {
  title: string;
  slugs: string[];
};

const GROUPS: Group[] = [
  {
    title: "Vendas",
    slugs: ["proposta-digital", "crm", "funil-de-vendas", "programa-de-indicacao"],
  },
  {
    title: "Operação",
    slugs: ["gestao-do-evento", "contrato-automatico", "monitoramento-ao-vivo"],
  },
  {
    title: "Financeiro & Dados",
    slugs: ["pagamento-integrado", "nota-fiscal", "insight-de-vendas"],
  },
  {
    title: "Relacionamento",
    slugs: ["mensageria-automatica", "feedback-whatsapp", "integracoes"],
  },
];

const NavLinks = () => {
  const plainLinks = [
    // { name: "Preços e Planos", path: "/precos-e-planos" }, // oculto temporariamente
    { name: "Blog", path: "/blog" },
    { name: "Materiais Gratuitos", path: "/materiais-gratuitos" },
  ];

  const bySlug = new Map(solucoes.map((s) => [s.slug, s]));

  return (
    <div className="hidden md:flex items-center gap-1">
      <DropdownMenu>
        <DropdownMenuTrigger
          className={`${navigationMenuTriggerStyle()} group inline-flex items-center gap-1 outline-none`}
        >
          Soluções AmeUp
          <ChevronDown className="h-3 w-3 transition-transform duration-150 group-data-[state=open]:rotate-180" />
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          sideOffset={8}
          className="w-[880px] z-[60] bg-popover p-6 rounded-xl shadow-lg border"
        >
          <div className="grid grid-cols-4 gap-x-8 gap-y-2">
            {GROUPS.map((group) => (
              <div key={group.title} className="flex flex-col">
                <h4 className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mb-3">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-1">
                  {group.slugs.map((slug) => {
                    const s = bySlug.get(slug);
                    if (!s) return null;
                    const Icon = s.icon;
                    return (
                      <li key={slug}>
                        <Link
                          to={`/solucoes/${slug}`}
                          className="group/item flex items-start gap-3 rounded-lg p-2 -mx-2 hover:bg-muted/60 transition-colors"
                        >
                          <span className="w-8 h-8 rounded-md bg-muted flex items-center justify-center flex-shrink-0 mt-0.5">
                            <Icon className="w-4 h-4 text-lime" />
                          </span>
                          <span className="flex flex-col leading-tight">
                            <span className="text-sm font-medium text-foreground group-hover/item:text-lime transition-colors">
                              {s.title}
                            </span>
                            <span className="text-xs text-muted-foreground line-clamp-2 mt-0.5">
                              {s.tagline}
                            </span>
                          </span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </DropdownMenuContent>
      </DropdownMenu>

      <NavigationMenu>
        <NavigationMenuList>
          {plainLinks.map((link) => (
            <NavigationMenuItem key={link.name}>
              <NavigationMenuLink className={navigationMenuTriggerStyle()} asChild>
                <Link to={link.path}>{link.name}</Link>
              </NavigationMenuLink>
            </NavigationMenuItem>
          ))}
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};

export default NavLinks;
